import withStyles from "react-jss"
import colors from "../../assets/colors"
import {
  MAX_WIDTH,
  SCROLLY_TEXTBOX_OUTER_PADDING,
} from "../../data/globalStyles"

const TEXT_BOTTOM_PADDING = "30px"

const styles = {
  container: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: MAX_WIDTH,
    margin: "0 auto",
    color: colors.black,
    ...SCROLLY_TEXTBOX_OUTER_PADDING,
  },
  textContainer: {
    boxSizing: "border-box",
    width: "100%",
    background: "#ffffff",
    borderRadius: "4px",
    padding: "32px 40px",
    "@media only screen and (max-width: 840px)": {
      padding: "16px",
    },
    "& > :last-child": {
      paddingBottom: 0,
    },
  },
  text: {
    boxSizing: "border-box",
    fontFamily: "BreveText",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "19px",
    margin: 0,
    paddingBottom: TEXT_BOTTOM_PADDING,
    color: "#000000",
    lineHeight: "1.5em",
  },
  figure: {
    margin: "0 auto",
    width: "100%",
    maxWidth: "600px",
    marginBottom: TEXT_BOTTOM_PADDING,
  },
  img: {
    width: "100%",
  },
  caption: {
    width: "100%",
    textAlign: "center",
    fontFamily: "WiredMono",
    fontWeight: 400,
    fontSize: "13px",
    letterSpacing: "-0.02em",
    textTransform: "uppercase",
    margin: "7px 0",
  },
  quote: {
    boxSizing: "border-box",
    margin: 0,
    marginBottom: TEXT_BOTTOM_PADDING,
    fontFamily: "BreveText",
    fontWeight: 400,
    fontSize: "32px",
    lineHeight: "36px",
    letterSpacing: "-0.02em",
    borderWidth: "0px 0px 0px 4px",
    borderStyle: "solid",
    borderColor: "rgb(26, 26, 26)",
    padding: "0px 1.5rem",
    "& span": {
      fontFamily: "WiredMono",
      fontSize: "11px",
      textTransform: "uppercase",
      color: "rgb(26,26,26)",
      fontWeight: 400
    },
    "@media (max-width: 480px)": {
      padding: "0px 1rem",
    },
  },
}

const TextSection = ({ classes, data }) => {
  if (!data?.length) return null
  const renderContent = (d, i) => {
    if (d.type === "text") {
      return (
        <p className={classes.text} key={i}>
          {d.content}
        </p>
      )
    } else if (d.type === "image") {
      return (
        <figure className={classes.figure} key={i}>
          <img className={classes.img} src={d.src} alt={d.alt} />
          <figcaption className={classes.caption}>{d.caption}</figcaption>
        </figure>
      )
    } else if (d.type === "blockquote") {
      return (
        <blockquote className={classes.quote} key={i}>
          {d.content}
        </blockquote>
      )
    }
  }
  return (
    <section className={classes.container}>
      <article className={classes.textContainer}>
        {data.map((d, i) => renderContent(d, i))}
      </article>
    </section>
  )
}

export default withStyles(styles)(TextSection)
